/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ADSEC){
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;

	const getJSONelationProducts = (_key) => {
		return $.getJSON(`/ajax/solution/${_key}.json`);
	};

	// 関連商品
	const pickupProducts = () => {
		$('.js-pickup-key').each((idx, ele) => {
			let count = 0;
			$(ele).find('.rt_pickup_key').each((idx2, ele2) => {
				let thisKey = $(ele2).text();
				if(idx2 < 4) {
					getJSONelationProducts(thisKey).then((data) => {
						count += 1;
						let productsData = data.rt_bn_products;
						let productsHtml;
						if(productsData.length) {
							let _name = productsData[0].cf_p_product;
							let _img = productsData[0].cf_p_thumbnail_img;
							let _cat = productsData[0].cf_p_category[0].cf_pc_first_code;
							productsHtml = '<li class="pure-u-1-4 pure-u-lg-1-2" style="order: '+count+';">'+
							'<a href="/products/'+_cat+'/'+thisKey+'/" class="mod-a"><figure>'+
							'<img src="/products/products_file/file/'+_img+'" alt="'+_name+'" class="width-u-100">'+
							'</figure><p class="fs_18 fs_md_16 fw_bold mt10">'+_name+'</p>'+
							'</a></li>';
							$(ele).parents('.js-pickup-wrap').find('.js-pickup-output').append(productsHtml);
						}
					});
				}
			});
		});
	};

	// ===================================================================
	if($('.js-pickup-output').length) {
		pickupProducts();
	}

})(window.jQuery, window.ADSEC);
